import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { HashRouter, Route, Routes } from "react-router-dom";
import React, { Suspense, useState } from "react";
// import Dashboard from "./views/dashboard/Dashboard";
import AboutUs from "./views/aboutUs/AboutUs";
import ForgotPassword from "./views/authScreens/forgotPassword/ForgotPassword";
import Register from "./views/authScreens/register/Register";
import LoginWithPassword from "./views/authScreens/loginWithPassword/LoginWithPassword";
import LoginWithOTP from "./views/authScreens/loginwithotp/LoginWithOTP";
import DefaultLayout from "./defaultLayout/DefaultLayout";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LandingPage from "./views/evac/LandingScreen";
import SupportPage from "./views/evac/CustomerSupport";
import PrivacyPolicy from "./views/privacyPolicy/PrivacyPolicy";
import TermAndCondition from "./views/termsAndCondition/TermAndCondition";
import NewAbout from "./views/newAbout/NewAbout";
import FAQ from "./views/faq/FAQ";
const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

function App() {
  const [theme, setTheme] = useState(
    window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light"
  );

  return (
    <HashRouter>
      <ToastContainer theme={theme === "dark" ? "light" : "dark"} />
      <Suspense fallback={loading}>
        <Routes>
          <Route path="*" name="Home" element={<DefaultLayout />} />
          <Route
            exact
            path="/landing"
            name="Landing"
            element={<LandingPage />}
          />
          <Route
            exact
            path="/evacsupport"
            name="SupportPage"
            element={<SupportPage />}
          />
          <Route
            exact
            path="/loginwithpassword"
            name="Login with otp Page"
            element={<LoginWithPassword />}
          />
          <Route
            exact
            path="/loginWithOTP"
            name="Login with otp Page"
            element={<LoginWithOTP />}
          />
          <Route
            exact
            path="/forgotPassword"
            name="Forgot Password Page"
            element={<ForgotPassword />}
          />
          <Route
            exact
            path="/register"
            name="Register Page"
            element={<Register />}
          />
          <Route
            exact
            path="/aboutUs"
            name="About Us Page"
            element={<AboutUs />}
          />
          <Route
            exact
            path="/PrivacyPolicy"
            name="Privacy Policy"
            element={<PrivacyPolicy />}
          />

          <Route
            path="/TermAndCondition"
            name="TermAndCondition"
            element={<TermAndCondition />}
          />
          <Route path="/NewAbout" name="NewAbout" element={<NewAbout />} />
          <Route path="/FAQ" name="FAQ" element={<FAQ />} />
        </Routes>
      </Suspense>
    </HashRouter>
  );
}

export default App;
